import { PanelBody } from "@wordpress/components";
import IconDisplay from "../../../../components/IconDisplay";

export default function State({ state, attributes, setAttributes }) {
  const { defaultIcon, hoverIcon, activeIcon } = attributes;

  return (
    <PanelBody
      title={
        <span style={{ textTransform: "capitalize" }}>{`${state} icon`}</span>
      }
      initialOpen={true}
    >
      <IconDisplay
        name={
          state === "default"
            ? defaultIcon.name
            : state === "hover"
            ? hoverIcon.name
            : activeIcon.name
        }
        type={
          state === "default"
            ? defaultIcon.type
            : state === "hover"
            ? hoverIcon.type
            : activeIcon.type
        }
        handleChangeAttributes={(updates) => {
          if (state === "default") {
            setAttributes({
              defaultIcon: { ...defaultIcon, ...updates },
            });
          } else if (state === "hover") {
            setAttributes({
              hoverIcon: { ...hoverIcon, ...updates },
            });
          } else if (state === "active") {
            setAttributes({
              activeIcon: { ...activeIcon, ...updates },
            });
          }
        }}
      />
    </PanelBody>
  );
}
